var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 100,
    viewBox: "0 0 90 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.9986 0.701299C38.6128 0.466972 33.6678 4.90521 28.313 7.69398C21.0299 12.0368 13.5302 16.0431 6.39219 20.6111C1.72334 24.4284 -0.421797 30.571 0.0685021 36.5028C0.0956858 47.02 0.0143328 57.5395 0.109575 68.0551C0.714165 74.4222 5.10324 79.8259 10.7511 82.4895C19.8178 87.724 28.8313 93.0558 37.9311 98.2291C43.7158 100.883 50.5639 99.7666 55.6812 96.1767C64.7213 90.8946 73.8173 85.7058 82.8219 80.3648C88.0017 76.6551 90.4605 70.1301 89.9289 63.8781C89.9018 53.3608 89.9833 42.8414 89.8879 32.3258C89.2827 25.9591 84.8944 20.5542 79.2459 17.8918C70.1791 12.6584 61.164 7.33011 52.0646 2.15616C49.8621 1.12704 47.4156 0.708085 44.9988 0.701099L44.9986 0.701299ZM39.3049 27.1858H50.6943V73.1969H39.3049V27.1858ZM53.6371 37.2004H65.0209V73.1969H53.6371V37.2004ZM24.9747 55.9785H36.3621V73.1969H24.9747V55.9783V55.9785Z",
    fill: "#5A4DC9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.c5349f996c3f91b0dff58d4d65b5e271.svg";
export { ForwardRef as ReactComponent };